var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSmolsrilanka(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    rx: 30,
    fill: "#0FBA68"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_20_170)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.7119 31.6949H34.0678V33.0509H32.7119V31.6949Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.373 19.4916L26.407 22.8814H33.5932L31.6271 19.4916H28.373Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.9321 30.3389H27.2881C27.2881 28.8473 28.5083 27.6271 29.9999 27.6271C31.4916 27.6271 32.7118 28.8473 32.7118 30.3389H34.0677V26.9491H25.9321V30.3389Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30 28.983C29.2541 28.983 28.644 29.5931 28.644 30.339H31.3559C31.3559 29.5931 30.7458 28.983 30 28.983Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.4238 26.9491H36.7798V30.3389H35.4238V26.9491Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.9321 24.2373H34.0677V25.5932H25.9321V24.2373Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.9321 31.6949H27.2881V33.0509H25.9321V31.6949Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.644 31.6949H31.3559V33.0509H28.644V31.6949Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30 37.1187C29.5931 37.1187 29.322 37.3898 29.322 37.7966V38.4746H30.678V37.7966C30.678 37.3898 30.4068 37.1187 30 37.1187Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.1526 22.8814H41.5254V22.5424L37.2543 19.4916H33.1865L35.1526 22.8814Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.1695 41.1864V39.0168L40.8475 37.6608V37.3219L40.1695 35.9659V34.4067H19.8306V35.8984L19.1526 37.2543V37.5933L19.8306 38.9492V41.1864H40.1695ZM33.3899 35.7627H38.8136V37.1186H33.3899V35.7627ZM33.3899 38.4745H38.8136V39.8305H33.3899V38.4745ZM27.9661 37.7966C27.9661 36.6439 28.8474 35.7627 30 35.7627C31.1527 35.7627 32.0339 36.6439 32.0339 37.7966V39.8305H27.9661V37.7966ZM21.1865 35.7627H26.6102V37.1186H21.1865V35.7627ZM21.1865 38.4745H26.6102V39.8305H21.1865V38.4745Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.8306 24.2373V30.339H21.8645V26.5423L21.1865 25.8644V24.2373H19.8306Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.6271 39.3558C47.6271 39.2883 47.6271 39.2204 47.5593 39.1525L46.9492 37.2544V37.1186C46.9492 36.7118 46.6781 36.4407 46.2712 36.4407C45.8644 36.4407 45.5932 36.7118 45.5932 37.1186V37.2544L44.9831 39.1525C44.9831 39.2204 44.9153 39.2883 44.9153 39.3558V41.1864H47.6271V39.3558Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.8306 31.6949H21.8645V33.0509H19.8306V31.6949Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.5764 24.2373H22.5425V25.3221L22.8136 25.5932H24.5764V24.2373Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.2205 31.6949H24.5764V33.0509H23.2205V31.6949Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.2205 26.9491H24.5764V30.3389H23.2205V26.9491Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.4577 25.3221V24.2373H35.4238V25.5932H37.1866L37.4577 25.3221Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.0847 39.3558C15.0847 39.2883 15.0847 39.2204 15.0168 39.1525L14.4067 37.2544V37.1186C14.4067 36.7118 14.1356 36.4407 13.7287 36.4407C13.3219 36.4407 13.0508 36.7118 13.0508 37.1186V37.2544L12.4407 39.1525C12.3728 39.2204 12.3728 39.2883 12.3728 39.3558V41.1864H15.0847V39.3558Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.4238 31.6949H36.7798V33.0509H35.4238V31.6949Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9831 14.7457H28.9152L25.051 18.1356H27.4914L28.9831 14.7457Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.8474 22.8814L26.8135 19.4916H22.7457L18.4746 22.5424V22.8814H24.8474Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.1355 31.6949H40.1694V33.0509H38.1355V31.6949Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.0001 15.7627L28.9832 18.1356H31.0171L30.0001 15.7627Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.1694 24.2373H38.8135V25.8644L38.1355 26.5423V30.339H40.1694V24.2373Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.9489 18.1356L31.0847 14.7457H31.0168L32.5085 18.1356H34.9489Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.305 48.6441V42.5424H11.6948V48.6441H10.3389V50H49.6609V48.6441H48.305ZM14.4067 47.2881H13.0507V43.8983H14.4067V47.2881ZM18.4745 47.2881H17.1185V43.8983H18.4745V47.2881ZM22.5423 47.2881H21.1863V43.8983H22.5423V47.2881ZM26.6101 47.2881H25.2541V43.8983H26.6101V47.2881ZM30.6779 47.2881H29.3219V43.8983H30.6779V47.2881ZM34.7456 47.2881H33.3897V43.8983H34.7456V47.2881ZM38.8134 47.2881H37.4575V43.8983H38.8134V47.2881ZM42.8812 47.2881H41.5253V43.8983H42.8812V47.2881ZM46.949 47.2881H45.5931V43.8983H46.949V47.2881Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.322 10H30.678V13.3898H29.322V10Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_20_170"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white",
    transform: "translate(10 10)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmolsrilanka);
export default __webpack_public_path__ + "static/media/smolsrilanka.b6cdc50a97d40a94c6a8619175fbe523.svg";
export { ForwardRef as ReactComponent };